export const DEFAULT_LAYOUT = 'AppLayoutDefault';
export const DEFAULT_REPORT_VIEW = 'Dashboard';
export const DEFAULT_GENERIC_REPORT_SALE = 'Sale';
export const DEFAULT_GENERIC_REPORT_EXPENSE = 'Expense';
export const DEFAULT_GENERIC_REPORT_PURCHASE = 'Purchase';
export const DEFAULT_PREDICTIONS_GENERIC_REPORT_SALE = 'PredictionsSale';
export const DEFAULT_ASSOCIATIONS_GENERIC_REPORT_SALE = 'Apriori';
export const DEFAULT_REPORT_INFO_VIEW = 'ReportsInfo';

export enum networkErrors {
  network = 'NETWORK_ERROR',
  server = 'SERVER_ERROR',
  perms = 'AUTHORIZATION_ERROR',
  auth = 'AUTHENTICATION_ERROR',
  validation = 'VALIDATION_ERROR',
  notFound = 'NOT_FOUND_ERROR',
  unprocessableEntity = 'UNPROCESSABLE_ENTITY_ERROR',
  maintenance = 'MAINTENANCE_ERROR',
}

export const unitTypes = ['quantity', 'volume', 'weight'];

export const baseVersion = process.env.VUE_APP_BASE_API_VERSION || '';
export const version = 'v5.1.2';
export const toastPresets = {
  success: {
    color: 'success',
  },
  error: {
    color: 'error',
  },
};
export const currencies = ['EUR', 'USD', 'GBP', 'YPJ', 'MXN', 'BLR', 'DOP'];
export const maxSpotsInTables = 75;
